import React from 'react';
import { TopToolbar, RefreshButton, ReferenceField, TextField, SelectInput, DateField, ListButton, ShowButton, Edit, SimpleForm, TextInput, NumberInput,required } from 'react-admin';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ basePath, data }) => (
    <TopToolbar>
        <RefreshButton />
        <ListButton basePath={basePath} />
        <ShowButton basePath={basePath} record={data} />
    </TopToolbar>
)

const EditTitle = ({ record }) => {
    return <span>Edit Ship-To {record ? `${record.name}` : ''}</span>;
};

const ShipTosEdit = ({ permissions, ...props }) => (
    <Edit actions={<EditActions />} {...props} title={<EditTitle />} >
        <SimpleForm>
            <ReferenceField label="Sold To Name" source="business_id" reference="businesses" link="show" allowEmpty>
                <TextField source="name" />
            </ReferenceField>
            <TextInput source="name" />
            <TextInput source="ship_to_sap_number" label="Ship To ID" disabled={true} />
            <NumberInput source="phone" />
            <SelectInput source="status" choices={[
                { id: true, name: 'True' },
                { id: false, name: 'False' },
            ]} 
                defaultValue="status"
                validate={required()}

            />
            {/* <DateField label={'Created at'} source="created_at" /> */}
            <TextInput source="created_at" label="Created at" disabled={true} />
        </SimpleForm>
    </Edit>
);

export default ShipTosEdit;